import axios from 'axios';
import { API_SERVER } from './constants';
import {
  getAccessToken,
  getRefreshToken,
  saveToken,
  clearTokens,
} from './tokenManager';

// Axios örneği oluştur
const apiClient = axios.create({
  baseURL: API_SERVER,
  withCredentials: true,
});

// İstek Interceptor'ı (Access Token Ekleme)
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken'); // Burada token'ı alın
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Yanıt Interceptor'ı (Refresh Token Kullanımı)
apiClient.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    // Eğer accessToken süresi dolmuşsa ve refreshToken kullanılabiliyorsa
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const accessToken = getAccessToken();
      const refreshToken = getRefreshToken();

      if (refreshToken) {
        try {
          // Refresh Token isteği yap
          const refreshResponse = await axios.post(
            `${API_SERVER}/identity/refresh-token`,
            {
              accessToken, // Mevcut accessToken
              refreshToken, // Mevcut refreshToken
            }
          );

          if (refreshResponse.status === 200) {
            const {
              accessToken: newAccessToken,
              refreshToken: newRefreshToken,
            } = refreshResponse.data;

            // Yeni token'ları kaydet
            saveToken(newAccessToken, newRefreshToken);

            // Orijinal isteği tekrar dene
            originalRequest.headers['Authorization'] =
              `Bearer ${newAccessToken}`;
            return apiClient(originalRequest);
          }
        } catch (refreshError) {
          console.error('Refresh token yenileme başarısız:', refreshError);
          clearTokens();
          window.location.href = '/login'; // Giriş sayfasına yönlendir
        }
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
